/**
 * Bodymania - Barra de envio gratis: montaje, refresco en vivo y animacion.
 * e-Growth, julio 2026. Se carga desde layout/theme.liquid, siempre.
 *
 * La logica de tramos vive en snippets/free-shipping-goal.liquid. Este fichero solo
 * trae HTML fresco del servidor, lo coloca y lo anima: el servidor es la unica fuente
 * de verdad, aqui no se recalcula ningun importe.
 *
 * Por que existe el modo "inyectar":
 * `sections/cart-drawer.liquid` envuelve su render en `if cart != empty`, asi que con el
 * carrito vacio no hay barra NI hueco donde ponerla. Al anadir el primer producto el tema
 * solo repinta #CartDrawerBody-*, que no la contiene, y no aparecia hasta recargar. Aqui se
 * detecta ese caso y se inserta la barra en su sitio en cuanto entra el primer articulo.
 */
(function () {
  if (window.__bmGoalBound) return;
  window.__bmGoalBound = true;

  var seq = 0;
  var estado = {}; // ultimo porcentaje pintado, por seccion
  var pendiente = {}; // timers de debounce, por seccion
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function idDe(section) {
    return section.id.replace(/^shopify-section-/, '');
  }

  /**
   * Secciones que tienen barra o que deberian tenerla. Se buscan tambien por los
   * contenedores del tema, porque cuando el carrito esta vacio no hay ningun
   * [data-bm-goal] del que tirar.
   */
  function secciones() {
    var out = [];

    function add(el) {
      if (!el) return;
      var s = el.closest('.shopify-section');
      if (s && out.indexOf(s) === -1) out.push(s);
    }

    document.querySelectorAll('[data-bm-goal]').forEach(add);
    add(document.querySelector('[id^="CartDrawerBody-"]'));
    add(document.querySelector('[id^="MainCart-"]'));

    return out;
  }

  /**
   * Coloca una barra recien traida cuando no habia ninguna. En el drawer va justo antes
   * de #CartDrawerBody-*, que es donde la pone el Liquid de la seccion.
   */
  function insertar(section, nodo) {
    var ancla = section.querySelector('[id^="CartDrawerBody-"]');
    if (ancla && ancla.parentElement) {
      ancla.parentElement.insertBefore(nodo, ancla);
      return true;
    }
    var cuerpo = section.querySelector('.drawer__body');
    if (cuerpo) {
      cuerpo.insertBefore(nodo, cuerpo.firstChild);
      return true;
    }
    return false;
  }

  /**
   * El contenido del mount se reemplaza entero, asi que el elemento de la barra es
   * SIEMPRE nuevo y nace con su ancho final: una `transition` de CSS a secas no se ve
   * jamas, porque no hay cambio de valor que transicionar.
   *
   * Se anima con la Web Animations API y NO tocando `style.width`. Un intento anterior
   * repintaba el ancho viejo, forzaba reflow y soltaba el nuevo; funcionaba suelto, pero
   * dejaba un width inline que se peleaba con los reemplazos del tema y, en cambios
   * rapidos seguidos, la barra se quedaba clavada en el valor anterior.
   */
  function animar(section) {
    var key = idDe(section);
    var mount = section.querySelector('[data-bm-goal]');
    if (!mount) return;

    var card = mount.querySelector('[data-bm-goal-card]');
    var fill = mount.querySelector('.bm-goal__fill');

    // Sin barra: carrito vacio, o carrito con bebidas (que no tiene envio gratis).
    // NO se borra `estado[key]`: durante el reemplazo hay estados intermedios en los que
    // el mount ya existe pero todavia no tiene barra dentro. Si aqui se borrase el valor
    // anterior, el disparo bueno se quedaria sin punto de partida y no animaria nada.
    if (!fill) return;

    var destino = parseFloat(fill.getAttribute('data-pct') || '0');
    if (isNaN(destino)) return;

    var anterior = estado[key];
    estado[key] = destino;

    if (anterior === undefined || anterior === destino) return;
    if (reduce.matches || typeof fill.animate !== 'function') return;

    fill.animate(
      [{ width: anterior + '%' }, { width: destino + '%' }],
      { duration: 550, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }
    );

    if (card) {
      card.classList.add(destino > anterior ? 'bm-goal--sube' : 'bm-goal--baja');
      if (destino >= 100 && anterior < 100) {
        card.classList.add('bm-goal--logrado');
      }
      setTimeout(function () {
        card.classList.remove('bm-goal--sube', 'bm-goal--baja', 'bm-goal--logrado');
      }, 1000);
    }
  }

  /**
   * Un reemplazo de carrito dispara del orden de media docena de mutaciones. Se coalescen
   * para animar una sola vez, cuando el DOM ya ha parado de moverse.
   */
  function animarPronto(section) {
    var key = idDe(section);
    clearTimeout(pendiente[key]);
    pendiente[key] = setTimeout(function () {
      animar(section);
    }, 60);
  }

  /**
   * El observer va sobre la SECCION, no sobre el mount: en /cart el tema reemplaza
   * #MainCart-* entero y destruye el nodo del mount, llevandose por delante cualquier
   * observer enganchado a el. La seccion, en cambio, siempre persiste.
   */
  function observar(section) {
    if (section.__bmObs) return;
    section.__bmObs = new MutationObserver(function () {
      animarPronto(section);
    });
    section.__bmObs.observe(section, { childList: true, subtree: true });
    animar(section); // fija el estado inicial, sin animar
  }

  function montar() {
    secciones().forEach(observar);
  }

  function refrescar() {
    var lista = secciones();
    if (!lista.length) return;

    var mine = ++seq;

    lista.forEach(function (section) {
      observar(section);

      var url = new URL(window.location.href);
      url.searchParams.set('section_id', idDe(section));

      fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function (html) {
          // Si mientras tanto ha entrado otra actualizacion, esta respuesta ya es vieja.
          if (mine !== seq) return;

          var fresco = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-bm-goal]');
          var mount = section.querySelector('[data-bm-goal]');

          // El servidor ya no pinta barra (carrito vaciado): fuera la que hubiera.
          if (!fresco) {
            if (mount) mount.remove();
            delete estado[idDe(section)];
            return;
          }

          // Primer articulo del carrito: no habia barra, se coloca en su sitio.
          if (!mount) {
            insertar(section, fresco);
            return;
          }

          if (fresco.innerHTML.trim() !== mount.innerHTML.trim()) {
            mount.innerHTML = fresco.innerHTML; // el observer se encarga de animar
          }
        })
        .catch(function () {
          // La barra es informativa: si falla, se queda como esta y no rompe el carrito.
        });
    });
  }

  ['cart:updated', 'cart:refresh', 'product-ajax:added'].forEach(function (evt) {
    document.addEventListener(evt, refrescar);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }
})();
